import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class HomeCurrencyFilter extends Component {
    state = {
        issuHomeCurrLists:[],
        issuHomeCurrValue: '',
        isHomeCurrLoading: true
    };
    componentDidMount(){
        this._get_home_curr(this.props.start_date,this.props.end_date);
    }
//     resetCard()
//     {
//         this.setState({
//             cardTypeValue: [],
//         })
//     }
    _get_home_curr(start_date, end_date){
        this.setState({
            issuHomeCurrLists:[],
            issuHomeCurrValue: [],
            isHomeCurrLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/dcc-homecurrency/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    issuHomeCurrLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((home_currency, index) => {
                    this.state.issuHomeCurrLists.push({value: home_currency.home_currency, label: home_currency.home_currency})
                });
            }
            this.setState({
                isHomeCurrLoading: false
            })
        });

    }


    changeIssuHome(optionSelected){
        let value='';
        let homeCurrArray = [];
        if(optionSelected.length < 1){
            value = null;
            homeCurrArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                homeCurrArray.push(mids.value)
                var index = this.state.issuHomeCurrLists.findIndex(obj => obj.value==mids.value);
                this.state.issuHomeCurrLists.move(index,0).join(',');
            });
        }

        this.props.onSelectHomeCurr(optionSelected, homeCurrArray);
        this.setState({
            issuHomeCurrValue:optionSelected,
        });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="home_curr"
                isMulti
                value={this.state.issuHomeCurrValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeIssuHome.bind(this)}
                options={this.state.issuHomeCurrLists}
                placeholderButtonLabel="Select [Home Currency]"
                isLoading={this.state.isHomeCurrLoading}
            />
        );

    }
}
export default HomeCurrencyFilter;